// extracted by mini-css-extract-plugin
export default {"wrapper":"DayNightToggle_wrapper__S4FSg","switch":"DayNightToggle_switch__oW0tH"};